import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

const Schema = yup.object().shape({
  status: yup.string().required('Please select'),
  comment: yup.string().max(10, 'Must have up to 10 characters'),
})

export const resolver = yupResolver(Schema)
